export const environment = {
  production: false,
  //endpoint: 'https://backend.helipagos.com',
  //endpointLogin: 'https://backend.helipagos.com',
  endpoint: "https://sandbox-be.helipagos.com",
  endpointLogin: "https://sandbox-be.helipagos.com",
   //endpoint: "http://192.168.100.122:8090", //IP VANE
   //endpointLogin: "http://192.168.100.122:8090", //IP VANE
  // URL del dashboard v2 (SSO por handoff)
  v2Url: 'https://adminv2.helipagos.com',
  version: '1.26.0-sanpshot',
};
